module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEaSURBVEhL5dQ9SwNBEMbxK9TeNl0KCy0FbYyQLqCdpUVawdZWFCxEBLt8BpuUgq2N+QJBKwPiG3bGKgQRkv8jOzBctrjzziLxgR+5m2xmcgu3yb/KNl6DLRXKzgtGwbMKZefPB2hbNETNGypMTRZxD9se84BVFM4h0s1NH2solB5izdvhU0PO8atBS0g3NvO4TNWWkSv78A08Sw0XuP65y5kqTvAE33yIBbTwGWperqzjDFcYQA2OcBquY6KxF+ktXFt24X/cxQa+w30TmeK34VGFkAp2oKE68DZxB1s3h0zR4vSAFVgt5gCZo3/3Dr9Fx4g1li/o6equ5mVK7IiQD+xBuUFszUQ6sC9vVSg7fnoZJhJbVMRMJEnGEpCtrHy+38EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-physical-therapy/dark/24.png
// module id = 2324
// module chunks = 2